import { http } from '../../../resources/http';

export async function getFirstUser(token: string): Promise<string> {
    const response = await http('GET /users/organization', {}, token);
    if (response.data.length === 0) {
        throw new Error('No users found in organization');
    }
    return response.data[0].id;
}
